import React, { useEffect, useRef, useState } from "react";
import { Bar } from "./bar/bar";
import { BarSmall } from "./bar/bar-small";
import { Milestone } from "./milestone/milestone";
import { Project } from "./project/project";
import style from "./task-list.module.scss";

export const TaskItem = (props) => {
  const {
    task,
    arrowIndent,
    isDelete,
    taskHeight,
    isSelected,
    rtl,
    onEventStart
  } = { ...props };

  const textRef = useRef(null);
  const [taskItem, setTaskItem] = useState(<div />);
  const [isTextInside, setIsTextInside] = useState(true);

  // Pick which bar type to render
  useEffect(() => {
    switch (task.typeInternal) {
    case "milestone":
      setTaskItem(<Milestone {...props} />);
      break;
    case "project":
      setTaskItem(<Project {...props} />);
      break;
    case "smalltask":
      setTaskItem(<BarSmall {...props} />);
      break;
    default:
      setTaskItem(<Bar {...props} />);
      break;
    }
  }, [task, isSelected]);

  // Check if text fits inside the bar
  useEffect(() => {
    if (textRef.current) {
      setIsTextInside(textRef.current.getBBox().width < task.x2 - task.x1);
    }
  }, [textRef, task]);

  // Calculate X position for label
  const getX = () => {
    const width = task.x2 - task.x1;
    const hasChild = task.barChildren.length > 0;

    if (isTextInside) {
      return task.x1 + width * 0.5;
    }

    if (rtl && textRef.current) {
      return (
        task.x1 -
        textRef.current.getBBox().width -
        arrowIndent * (hasChild ? 1 : 0) -
        arrowIndent * 0.2
      );
    }

    return (
      task.x1 +
      width +
      arrowIndent * (hasChild ? 1 : 0) +
      arrowIndent * 0.2
    );
  };

  return (
    <g
      onKeyDown={(e) => {
        if (e.key === "Delete" && isDelete) {
          onEventStart("delete", task, e);
        }
        e.stopPropagation();
      }}
      onMouseEnter={(e) => onEventStart("mouseenter", task, e)}
      onMouseLeave={(e) => onEventStart("mouseleave", task, e)}
      onDoubleClick={(e) => onEventStart("dblclick", task, e)}
      onClick={(e) => onEventStart("click", task, e)}
      onFocus={() => onEventStart("select", task)}
    >
      {taskItem}

      <text
        x={getX()}
        y={task.y + taskHeight * 0.5}
        className={
          isTextInside ? style.barLabel : style.barLabelOutside
        }
        ref={textRef}
      >
        {task.name}
      </text>
    </g>
  );
};
